import React from 'react';
import {useTranslation} from 'react-i18next';
import SignaturePad from 'react-signature-pad-wrapper';
import {STORAGE_KEYS} from 'utils/constants';
import {SessionStorage} from 'utils/storage';
import Button from '../../common/Button';
import {
  ModalHeader,
  Row,
  ModalTitleText,
  ButtonsWrapper,
  ModalWrapper,
  ModalSubTitle,
} from './styled';

type ModalTypes = {
  onClose: () => void;
  signature: SignaturePad | null;
  signatureArea: JSX.Element;
  onChange: (value: string) => void;
  hasSignature?: boolean;
  checkIsSignatureEmpty?: boolean;
};

function SignatureModal({
  onClose,
  signatureArea,
  signature,
  onChange,
  hasSignature,
}: ModalTypes) {
  const {t} = useTranslation();

  const handleNextButton = () => {
    const signatureDataURL = signature?.canvas?.current?.toDataURL();
    const isEmpty = signature?.isEmpty();
    if (!isEmpty) {
      if (signatureDataURL) onChange(signatureDataURL);
      SessionStorage.set(STORAGE_KEYS.personalSignatureFormData, signatureDataURL);
      onClose();
      return;
    }
    console.error('ERROR SAVING SIGNATURE SignatureModal line 37');
  };

  const clearArea = React.useCallback(() => {
    signature?.clear();
    SessionStorage.remove(STORAGE_KEYS.personalSignatureFormData);
    onChange('');
  }, [onChange, signature]);

  const handleCancelModal = React.useCallback(() => {
    onChange('');
    clearArea();
    onClose();
  }, [onChange, clearArea, onClose]);

  return (
    <div className="signature-modal">
      <ModalHeader className="signature-modal__header">
        <Row className="signature-modal__title">
          {/* <StyledIcon name="successIcon" size="32px" color="white" /> */}
          <ModalTitleText>{t('draw_your_signature')}</ModalTitleText>
        </Row>
        <ModalSubTitle className="signature-modal__subtitle">
          {t('signature_subtitle')}
        </ModalSubTitle>
      </ModalHeader>
      <ModalWrapper className="signature-modal__content">
        {/* <ClearButton onClick={clearArea}>{t('clear')}</ClearButton>  */}
        {signatureArea}
        <ButtonsWrapper>
          <Button
            primary
            label={t('confirm_signature')}
            onClick={handleNextButton}
            disabled={!hasSignature}
          />
          <Button link label={t('cancel')} onClick={handleCancelModal} />
        </ButtonsWrapper>
      </ModalWrapper>
    </div>
  );
}

export {SignatureModal};
